import SvgIcon from "@mui/material/SvgIcon";

export const PlayButton = (props) => (
  <SvgIcon {...props} viewBox="0 0 60 60">
    <g id="组_1836" data-name="组 1836" transform="translate(-610 -1494)">
      <path
        id="椭圆_349"
        data-name="椭圆 349"
        d="M30,1A29.008,29.008,0,0,0,18.712,56.721,29.008,29.008,0,0,0,41.288,3.279,28.818,28.818,0,0,0,30,1m0-1A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z"
        transform="translate(610 1494)"
        fill="#fff"
      />
      <path
        id="多边形_3"
        data-name="多边形 3"
        d="M8.3,3.146a2,2,0,0,1,3.5,0l6.647,11.962a2,2,0,0,1-1.748,2.971H3.4a2,2,0,0,1-1.748-2.971Z"
        transform="translate(651.079 1514) rotate(90)"
        fill="#fff"
      />
    </g>
  </SvgIcon>
);
